import { v4 as uuidV4 } from "uuid";

import { parseQueryString } from "shared/lib/utils";

import { MaxKeywordLength } from "./consts";

export function generateStreamId() {
  return `web-${uuidV4()}-${Date.now()}`;
}

export function getCleanRouteQueryValue(value: string | string[] | undefined) {
  return sanitizeKeyword(parseQueryString(value) ?? "");
}

export function sanitizeKeyword(keyword?: string) {
  return keyword?.trim()?.slice(0, MaxKeywordLength) ?? "";
}
